import { DASH } from '../lib/money'
import type { Tone } from './ui'

export function resultTone(result: string | null | undefined): Tone {
  const r = (result ?? '').toLowerCase()
  if (/succe|paid|ok|finished/.test(r)) return 'ok'
  if (/declin|refus|fail|error|denied/.test(r)) return 'warn'
  if (/unknown|timeout/.test(r)) return 'crit'
  return 'mute'
}

/** Params of an admin operation as compact `key: value` text. Secret-named
 * fields never get here (stripped on arrival, src/api/http.ts). */
export function paramsText(params: Record<string, unknown> | null | undefined): string {
  if (!params || Object.keys(params).length === 0) return DASH
  return Object.entries(params)
    .map(([k, v]) => `${k}: ${typeof v === 'object' ? JSON.stringify(v) : String(v)}`)
    .join(' · ')
}

